import { Grid } from "@mui/material";
import { Box } from "@mui/material";
import FormInput from "./FormInput";
import logoDark from "../../../assets/images/signin/logoDark.png";
import AuthFooter from "../auth-layout/auth-footer";
import "./forgot-password.scss";

const ForgotPassword = () => {
  return (
    <>
      <div className={`forgot-password`} >
        <Grid container>
          {/* Forgot password banner image*/}
          <Grid item xl={8} md={6}>
            <Box className={`bg-banner-image`} sx={{ display: {}, }}></Box>
          </Grid>

          {/* Forgot password main layout*/}
          <Grid item xl={4} md={6} xs={12} sx={{ backgroundColor: "#f0f3fb", px: '4.16vw' }}>
            <Box sx={{ height: { md: '100vh', xs: 'auto' } }}>
              <Box className="loginContainer" >
               <Box  sx={{textAlign:"center"}}>
               <img className="logoImg" src={logoDark} alt="ppcn_logo" />
               </Box>
                <div className={`loginForm`} style={{ justifyContent: 'center' }}>
                  <FormInput />
                </div>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </div>
      <AuthFooter />
    </>
  );
};
export default ForgotPassword;
